import React, { useEffect, useState } from "react";
import { usePopup } from "./PopupContext";
import InputField from "./form/InputField";
import { useMediaQuery } from "react-responsive";
import Button from "./common/Button";
import { sendEmail } from "../backend/email/email";

const RespondPopup = ({ visible, showEmail }) => {
  const { hide } = usePopup();

  const [email, setEmail] = useState("");
  const [comment, setComment] = useState("");
  const [errors, setErrors] = useState({ email: "", comment: "" });

  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [submitError, setSubmitError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const isSmall = useMediaQuery({ query: "(max-width: 450px)" });
  const isMedium = useMediaQuery({ query: "(max-width: 700px)" });
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  useEffect(() => {
    if (visible) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [visible]);

  const validate = () => {
    const newErrors = { email: "", comment: "" };
    let valid = true;

    if (showEmail && !email.trim()) {
      newErrors.email = "Вкажіть електронну пошту";
      valid = false;
    }

    if (!comment.trim()) {
      newErrors.comment = "Поле обов'язкове";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleSubmit = async () => {
    if (!validate() || isSubmitting) return;
    setIsSubmitting(true);

    try {
      const result = await sendEmail(email, comment);
      setIsSubmitting(false);
      if (result) {
      setSubmitError("");
        setSubmitSuccess(true);
        setEmail("");
        setComment("");
        setErrors({ email: "", comment: "" });
        setTimeout(() => {
          setSubmitSuccess(false);
          hide();
        }, 2000);
      } else {
        setSubmitError("Виникла помилка при відправленні форми. Будь ласка, спробуйте ще раз.");
        setSubmitSuccess(false);
        setErrors({ email: "", comment: "" });
      }
    } catch (error) {
      console.error(error);
      setSubmitError("Сталася помилка. Спробуйте ще раз.");
    }
  };

  if (!visible) return null;

  return (
    <div style={styles.popupWrapper}>
      <div
        style={{
          ...styles.popupContainer,
          width: isMobile ? "100vw" : "65vw",
        }}
      >
        <div style={styles.headerRow}>
          <p style={styles.heading}>Відгукнутися</p>
          <div
            style={styles.closeButtonContainer}
            onClick={() => {
              hide();
              setSubmitError("");
              setSubmitSuccess(false);
              setErrors({ email: "", comment: "" });
              setEmail("");
              setComment("");
            }}
          >
            <img style={styles.closeButton} src={"assets/icons/close.svg"} />
          </div>
        </div>
        <div style={styles.mainContainer}>
          {submitError && <p style={styles.formError}>{submitError}</p>}
          {submitSuccess ? (
            <div style={styles.successMessage}>
              <p>Дякуємо! Ваше повідомлення успішно відправлено.</p>
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                height: "100%",
              }}
            >
              <div style={{ display: "flex", flexDirection: "column", gap: "2rem" }}>
                {showEmail && (
                  <InputField
                    heading={"Електронна пошта"}
                    isRequired={true}
                    hintText={"user@example.com"}
                    onChanged={setEmail}
                    errorMessage={errors.email}
                    type="email"
                  />
                )}
                <InputField
                  heading={"Коментар"}
                  isRequired={true}
                  hintText={""}
                  onChanged={setComment}
                  errorMessage={errors.comment}
                  big={true}
                  minHeight={showEmail ? "35vh" : "45vh"}
                />
              </div>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <button
                  onClick={handleSubmit}
                  style={{
                    ...styles.submitButton,
                    fontSize: isSmall ? "1.2rem" : isMedium ? "1.5rem" : "1.8rem",
                  }}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Відправляємо..." : "Відправити"}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  popupWrapper: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backdropFilter: "blur(4px)",
    backgroundColor: "rgba(0, 0, 0, 0.3)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 19999,
    overflow: "hidden",
  },
  popupContainer: {
    display: "flex",
    backgroundColor: "white",
    height: "85vh",
    overflowY: "auto",
    flexDirection: "column",
  },
  mainContainer: {
    display: "flex",
    padding: "2rem",
    flexDirection: "column",
    flex: "1 1 100%",
  },
  headerRow: {
    backgroundColor: "var(--olive)",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  heading: {
    fontWeight: "bold",
    fontSize: "1.5rem",
    marginLeft: "1.5rem",
  },
  closeButtonContainer: {
    aspectRatio: "1",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "1.5rem",
    cursor: "pointer",
  },
  closeButton: {
    height: "2.5rem",
    width: "2.5rem",
  },
  successMessage: {
    backgroundColor: "rgba(0, 128, 0, 0.1)",
    padding: "2rem",
    borderRadius: "0.5rem",
    textAlign: "center",
  },
  formError: {
    color: "#FF0000",
    fontSize: "1rem",
    padding: "1rem",
    backgroundColor: "rgba(255, 0, 0, 0.05)",
    borderRadius: "0.5rem",
    marginBottom: "1rem",
  },
  submitButton: {
    display: "block",
    color: "var(--black)",
    border: "3px solid var(--black)",
    backgroundColor: "var(--white)",
    lineHeight: "3rem",
    padding: "1rem 3rem",
    fontWeight: "bold",
    cursor: "pointer",
  },
};

export default RespondPopup;
